module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "loi"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0006#toc"
    }
  }, [_vm._v("Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0201"
    }
  }, [_vm._v("2.1")]), _vm._v("   Correlations between party identification and candidate/president affect, 1956–2004")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0202"
    }
  }, [_vm._v("2.2")]), _vm._v("   Correlations between party identification and president / presidential candidate thermometers, 1968–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0203a"
    }
  }, [_vm._v("2.3a")]), _vm._v("   Correlations between party identification and favorable views of Bush, Gore, and Clinton, December 1999–January 2001")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0203b"
    }
  }, [_vm._v("2.3b")]), _vm._v("   Correlations between party identification and favorable views of Bush and Kerry, October 2003–November 2004")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0203c"
    }
  }, [_vm._v("2.3c")]), _vm._v("   Correlations between party identification and favorable views of Obama, McCain, H. Clinton, and Bush, December 2007–November 2008")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0204"
    }
  }, [_vm._v("2.4")]), _vm._v("   Favorability of partisans toward Obama and McCain, December 2007 through November 2008")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0205"
    }
  }, [_vm._v("2.5")]), _vm._v("   Correlations between party identification and thermometer ratings of Obama, H. Clinton, Bush, and McCain, 2008–2009")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0206a"
    }
  }, [_vm._v("2.6a")]), _vm._v("   Effect of presidential or presidential candidate affect on party affect, controlling for party identification, Republicans")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0206b"
    }
  }, [_vm._v("2.6b")]), _vm._v("   Effect of presidential or presidential candidate affect on party affect, controlling for party identification, Democrats")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0207"
    }
  }, [_vm._v("2.7")]), _vm._v("   Effect of ratings of candidates/presidents on ratings of their parties, by status and party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0208"
    }
  }, [_vm._v("2.8")]), _vm._v("   Effect of presidents’ / presidential candidates’ thermometer ratings on party thermometer ratings, controlling for party identification, 1978–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0209"
    }
  }, [_vm._v("2.9")]), _vm._v("   Correlations between candidate and party affect, by party identification, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0210"
    }
  }, [_vm._v("2.10")]), _vm._v("   Relative impact of party identification and candidate affect on party affect")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0211"
    }
  }, [_vm._v("2.11")]), _vm._v("   Relative impact of candidate/president affect on party affect, controlling for party identification, January–October 2008")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiv"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0212"
    }
  }, [_vm._v("2.12")]), _vm._v("   Relative effect of Eisenhower and Nixon affect on Republican Party affect, 1956–1968, controlling for party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0213"
    }
  }, [_vm._v("2.13")]), _vm._v("   Relative effect of Republican leaders’ affect on party affect, controlling for party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0214"
    }
  }, [_vm._v("2.14")]), _vm._v("   Relative effect of Democratic president/candidate thermometer on Democratic Party thermometer, controlling for party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#fig0215"
    }
  }, [_vm._v("2.15")]), _vm._v("   Relative effect of Republican president/candidate thermometers on Republican Party thermometer, controlling for party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0301a"
    }
  }, [_vm._v("3.1a")]), _vm._v("   Presidential approval and favorable opinions of the president’s party, Clinton, G. W. Bush, and Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0301b"
    }
  }, [_vm._v("3.1b")]), _vm._v("   Positive opinions of the president and his party, Clinton, G. W. Bush, and Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0302"
    }
  }, [_vm._v("3.2")]), _vm._v("   Approval of G. W. Bush’s performance and favorable opinions of the Republican Party across time")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0303a"
    }
  }, [_vm._v("3.3a")]), _vm._v("   Approval of Bill Clinton’s performance and favorable opinion of the Democratic Party, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0303b"
    }
  }, [_vm._v("3.3b")]), _vm._v("   Approval of George W. Bush’s performance and favorable opinions of the Republican Party, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0303c"
    }
  }, [_vm._v("3.3c")]), _vm._v("   Approval of Barack Obama’s performance and favorable opinions of the Democratic Party, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0304"
    }
  }, [_vm._v("3.4")]), _vm._v("   Strength of opinions of president and favorable opinions of his party")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0305"
    }
  }, [_vm._v("3.5")]), _vm._v("   Approval of the president and Congress 1993–2016 (quarterly averages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0306"
    }
  }, [_vm._v("3.6")]), _vm._v("   Approval of the president’s job performance and approval of his party or party leaders in Congress")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0307a"
    }
  }, [_vm._v("3.7a")]), _vm._v("   Approval of Clinton and Democrats in Congress, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0307b"
    }
  }, [_vm._v("3.7b")]), _vm._v("   Approval of G. W. Bush and Republicans in Congress, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0307c"
    }
  }, [_vm._v("3.7c")]), _vm._v("   Approval of Obama and Democrats in Congress, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0308"
    }
  }, [_vm._v("3.8")]), _vm._v("   Rating of president and president’s party in congress as doing an “excellent” or “pretty good” job (Harris Polls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#fig0309"
    }
  }, [_vm._v("3.9")]), _vm._v("   Mean thermometer scores for the president and his party, by party identification, 1978–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0401"
    }
  }, [_vm._v("4.1")]), _vm._v("   Party superiority on handling the most important problem, Truman through Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0402"
    }
  }, [_vm._v("4.2")]), _vm._v("   Partisan opinions of party competence, Truman through Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0403"
    }
  }, [_vm._v("4.3")]), _vm._v("   Presidential approval and relative party preference on most important problem")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0404"
    }
  }, [_vm._v("4.4")]), _vm._v("   Approval of Clinton’s performance, by domain (quarterly averages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxv"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0405"
    }
  }, [_vm._v("4.5")]), _vm._v("   Approval of G. W. Bush’s performance, by domain (quarterly averages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0406"
    }
  }, [_vm._v("4.6")]), _vm._v("   Approval of Obama’s performance, by domain (quarterly averages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0407"
    }
  }, [_vm._v("4.7")]), _vm._v("   Party advantage on handling the economy, 1981–2017")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0408"
    }
  }, [_vm._v("4.8")]), _vm._v("   Approval on economy and party advantage on the economy")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0409"
    }
  }, [_vm._v("4.9")]), _vm._v("   Average annual Democratic advantage in dealing with health care issues")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0410"
    }
  }, [_vm._v("4.10")]), _vm._v("   Opinions on the ACA, Obama’s handling of health care, and Democratic Party superiority on health care")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0411"
    }
  }, [_vm._v("4.11")]), _vm._v("   Democratic Party advantage on handling education")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0412"
    }
  }, [_vm._v("4.12")]), _vm._v("   Party advantage on handling foreign policy, G. H. W. Bush to Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0413"
    }
  }, [_vm._v("4.13")]), _vm._v("   Presidential approval on foreign policy and president’s party’s advantage on foreign policy")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0414"
    }
  }, [_vm._v("4.14")]), _vm._v("   Party advantage on handling terrorism, 2001–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0415"
    }
  }, [_vm._v("4.15")]), _vm._v("   Approval of G. W. Bush’s handling of terrorism and the Republican Party’s advantage on the issue")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0416"
    }
  }, [_vm._v("4.16")]), _vm._v("   Party better able to prevent World War III")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#fig0417"
    }
  }, [_vm._v("4.17")]), _vm._v("   Presidential approval and opinion on which party cares more about “people like you” or “the middle class”")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#fig0501"
    }
  }, [_vm._v("5.1")]), _vm._v("   Ideological location of parties and presidential candidates, by partisans")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#fig0502"
    }
  }, [_vm._v("5.2")]), _vm._v("   Average locations of the parties and presidents / presidential candidates on the liberal–conservative scale, 1972–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#fig0503"
    }
  }, [_vm._v("5.3")]), _vm._v("   Location of presidents/candidates and parties on 7-point scales, 1972–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#fig0601"
    }
  }, [_vm._v("6.1")]), _vm._v("   Party identification, 1993–2016 (leaners excluded)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#fig0602"
    }
  }, [_vm._v("6.2")]), _vm._v("   Party identification, 1993–2016 (leaners included)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#fig0603"
    }
  }, [_vm._v("6.3")]), _vm._v("   Democrats’ share of party identifiers, 1993–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#fig0604"
    }
  }, [_vm._v("6.4")]), _vm._v("   Presidential approval and macropartisanship, Clinton, G. W. Bush, and Obama administrations (monthly averages of Gallup Polls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0701"
    }
  }, [_vm._v("7.1")]), _vm._v("   Party identification, by year respondent turned 20 (leaners included)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0702"
    }
  }, [_vm._v("7.2")]), _vm._v("   Party identification, by year respondent turned 20 (leaners excluded)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0703"
    }
  }, [_vm._v("7.3")]), _vm._v("   Party identification by president at age 20 (leaners included)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0704"
    }
  }, [_vm._v("7.4")]), _vm._v("   Party identification by president at age 20 (no leaners)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0705"
    }
  }, [_vm._v("7.5")]), _vm._v("   Democratic share of party identifiers by race/ethnicity and year respondent turned 20 (leaners included)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0706"
    }
  }, [_vm._v("7.6")]), _vm._v("   Racial/ethnic composition of the respondent population by year respondent turned 20")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0707"
    }
  }, [_vm._v("7.7")]), _vm._v("   Approval of Barack Obama’s job performance, 2009–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxvi"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0708"
    }
  }, [_vm._v("7.8")]), _vm._v("   Approval of Obama’s job performance, by age group")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0709"
    }
  }, [_vm._v("7.9")]), _vm._v("   Approval of G. W. Bush’s job performance, by age group")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0710"
    }
  }, [_vm._v("7.10")]), _vm._v("   Approval of Obama’s performance by party and year respondent turned 20, 2014–2015")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0711"
    }
  }, [_vm._v("7.11")]), _vm._v("   Ideology by year respondent turned 20")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0712"
    }
  }, [_vm._v("7.12")]), _vm._v("   Ideology of Republicans by year respondent turned 20")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0713"
    }
  }, [_vm._v("7.13")]), _vm._v("   Ideology of Democrats by year respondent turned 20")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0714"
    }
  }, [_vm._v("7.14")]), _vm._v("   Ideology of pure independents by year respondent turned 20")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0715"
    }
  }, [_vm._v("7.15")]), _vm._v("   Summary issue positions, by party ID and age group, 2014")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0716"
    }
  }, [_vm._v("7.16")]), _vm._v("   Republicans’ opinions and media use, by age group")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#fig0717"
    }
  }, [_vm._v("7.17")]), _vm._v("   Approval of Obama’s performance, by race/ethnicity")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0801"
    }
  }, [_vm._v("8.1")]), _vm._v("   Effect of the presidential vote on the House Vote 1952–2016 (regression and correlation coefficients)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0802"
    }
  }, [_vm._v("8.2")]), _vm._v("   Effects of the presidential vote on the Senate Vote, 1948–2016 (regression and correlation coefficients)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0803"
    }
  }, [_vm._v("8.3")]), _vm._v("   States and districts delivering split outcomes in presidential and congressional contests, 1952–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0804"
    }
  }, [_vm._v("8.4")]), _vm._v("   Ticket splitting in national elections, 1952–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0805"
    }
  }, [_vm._v("8.5")]), _vm._v("   Party loyalty and defection in presidential and House elections, 1952–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0806"
    }
  }, [_vm._v("8.6")]), _vm._v("   Party loyalty and defection in presidential and Senate elections, 1952–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0807"
    }
  }, [_vm._v("8.7")]), _vm._v("   Correlations between the vote for president, state assembly, US House, and party registration in California, 1968–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0808"
    }
  }, [_vm._v("8.8")]), _vm._v("   Presidential approval and generic US House vote")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0809"
    }
  }, [_vm._v("8.9")]), _vm._v("   Presidential approval and preference for party control of Congress")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0810"
    }
  }, [_vm._v("8.10")]), _vm._v("   Midterm House and Senate votes congruent with presidential approval, 1946–2014 (percent)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0811"
    }
  }, [_vm._v("8.11")]), _vm._v("   Effects of presidential approval on the House and Senate vote, controlling for incumbency and party identification, midterm elections")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0812"
    }
  }, [_vm._v("8.12")]), _vm._v("   Effects of presidential approval on the House and Senate vote, controlling for incumbency and party identification, presidential election years")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#fig0813"
    }
  }, [_vm._v("8.13")]), _vm._v("   Is your vote for Congress a vote for or against the president?")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#fig0901"
    }
  }, [_vm._v("9.1")]), _vm._v("   Partisan differences in presidential approval, Eisenhower to Trump (quarterly averages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#fig0902"
    }
  }, [_vm._v("9.2")]), _vm._v("   Partisan thermometer ratings of presidential candidates, 1968–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#fig0903"
    }
  }, [_vm._v("9.3")]), _vm._v("   Correlations between racial resentment and reactions to parties and candidates")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxvii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#fig0904"
    }
  }, [_vm._v("9.4")]), _vm._v("   Approval of Trump’s job performance, January 2017–April 2018")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#fig0905"
    }
  }, [_vm._v("9.5")]), _vm._v("   Approval of Obama and Trump’s job performances, by demographics (Obama’s last year, Trump’s first year)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#fig0906"
    }
  }, [_vm._v("9.6")]), _vm._v("   Republicans’ opinions of Trump, the Republican Party, and Republicans in Congress and their leaders")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747f7fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-jacobson-0008.vue
// module id = 75
// module chunks = 0